export default {"src":"/_next/static/media/user-invites.d62e52ca.svg","height":500,"width":798,"blurWidth":0,"blurHeight":0};